import { useContext } from 'react';

import Card from '../ui/Card';
import classes from './NoteItem.module.css';
import FavoritesContext from '../store/favorites-context';

function NoteItem(props) {
    const favoriteCtx = useContext(FavoritesContext);

    const itemIsFavorite = favoriteCtx.itemIsFavorite(props.id);

    function toggleFavoriteStatusHandler() {
        if (itemIsFavorite) {
            favoriteCtx.removeFavorite(props.id);
        }
        else {
            favoriteCtx.addFavorite({
                id: props.id,
                title: props.title,
                image: props.image,
                dt: props.dt,
                detail: props.detail

            });
        }
    }
    return (
        <li className={classes.item}>
        <Card>
        <div className={classes.image}>
          <img src={props.image} alt={props.title} />  
        </div>
        <div className={classes.content}>
            <h3>{props.title}</h3>
            <address>{props.dt}</address>
            <p>{props.detail}</p>
        </div>
        <div className={classes.actions}>
            <button className={classes.myButton} onClick={toggleFavoriteStatusHandler}>
                {itemIsFavorite ? 'Remove from Favorites' : 'To Favorites'}
            </button>
        </div>
        </Card>
        </li>
    );   
}

export default NoteItem;
